import { Calendar } from "primereact/calendar";
import React, { useState } from "react";
import { formatDateTimeNew } from "../../components/globalFunctions/globalFunctions";

const BoardData = ({ item, handleDragStart, columnId, onClickTaskDetail, onAddSubtask, isSubtask = false }) => {
  const [activeSubtask, setActiveSubtask] = useState(false);
  const { id, title, dueDate, description, sub_tasks } = item;

  return (
    <>
      <div className="board" draggable={!isSubtask} onDragStart={() => handleDragStart(columnId, item)}>
        <div onClick={() => onClickTaskDetail(item, item.id)} style={{ cursor: "pointer" }}>
          <h5>{title}</h5>
          <ul className="board-list">
            <li>
              <i class="ri-calendar-line"></i>
              <span>Due date</span>: {dueDate ? formatDateTimeNew(dueDate) : "--"}
            </li>
            <li>
              <i className="ri-user-add-line"></i>
              <span>Assignee</span>: Jhon Deo
            </li>
            <li>
              <i className="ri-flag-2-line"></i>
              <span>Priority</span>: Normal
            </li>
          </ul>
          <ul className="board-btn-tags">
            <li>Development</li>
            <li>Elevated</li>
          </ul>
          {/* <div className="board-btns-group">
            <span className="board-btns">
              <i className="ri-user-add-line"></i>
            </span>
            <span className="board-btns">
              <Calendar className="task-table-calendar" value={dueDate} dateFormat="M dd" showButtonBar showIcon />
            </span>
          </div> */}
        </div>
        <div className="board-hover-btn-group">
          <button type="button" className="button" title="Mark as complete">
            <i className="ri-check-line"></i>
          </button>
          {!isSubtask && (
            <button type="button" className="button" title="Add Subtask" onClick={() => onAddSubtask(item.id)}>
              <i className="ri-add-circle-line"></i>
            </button>
          )}
          <button type="button" className="button task-more-link" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i className="ri-more-fill"></i>
          </button>
          <div className="dropdown task-dropdown">
            <div className="dropdown-menu dropdown-menu-end">
              <a className="dropdown-item" href="#">
                <i className="ri-box-3-line"></i> Task type
              </a>
              <a className="dropdown-item" href="#">
                <i className="ri-file-copy-line"></i> Duplicate
              </a>
              <a className="dropdown-item" href="#">
                <i className="ri-logout-box-r-line"></i> Move
              </a>
              <a className="dropdown-item" href="#">
                <i className="ri-mail-send-line"></i> Send email
              </a>
              <a className="dropdown-item" href="#">
                <i className="ri-layout-5-line"></i> Templates
              </a>
              <div className="dropdown-divider my-1"></div>
              <a className="dropdown-item" href="#">
                <i className="ri-archive-line"></i> Archive
              </a>
              <button type="button" className="dropdown-item dropdown-item-delete">
                <i className="ri-delete-bin-line"></i> Delete
              </button>
            </div>
          </div>
        </div>
        {sub_tasks?.length > 0 && (
          <button type="button" className="board-subtask-link" onClick={() => setActiveSubtask(!activeSubtask)}>
            <i className="ri-git-merge-line"></i> &nbsp;{sub_tasks.length} Subtasks
          </button>
        )}
      </div>

      {activeSubtask && sub_tasks?.length > 0 && (
        <div className="board-sub">
          {sub_tasks.map((subtask) => (
            <BoardData key={subtask.id} item={subtask} handleDragStart={handleDragStart} columnId={columnId} onClickTaskDetail={onClickTaskDetail} isSubtask={true} />
          ))}
        </div>
      )}
    </>
  );
};

export default BoardData;
